import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { currentWeek } from "@/lib/week";
import { LoadError, errMessage } from "@/components/LoadError";
import AfspraakDialog from "@/components/AfspraakDialog";
import AfspraakAfsluitDialog from "@/components/AfspraakAfsluitDialog";
import { AfdelingLijst } from "@/components/afdelingen/AfdelingLijst";
import { OverlegPaneel } from "@/components/afdelingen/OverlegPaneel";

// v19-B3: het weekoverleg met de afdelingen (oversight). Desktop eerst; op de telefoon onder elkaar.
export default function Afdelingen() {
  const [params, setParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [meta, setMeta] = useState(null);
  const [fout, setFout] = useState("");
  const [versie, setVersie] = useState(0);
  const [afsluit, setAfsluit] = useState(null);
  const [nieuw, setNieuw] = useState(false);
  const paneel = useRef(null);
  const laad = useCallback(() => api.get("/afdelingen/overzicht").then((r) => { setData(r.data); setFout(""); }).catch((e) => setFout(errMessage(e))), []);
  useEffect(() => { laad(); api.get("/meta").then((r) => setMeta(r.data)).catch(() => {}); }, [laad]);
  const gekozen = params.get("afd") || data?.afdelingen[0]?.id;
  const kies = (id) => {
    setParams({ afd: id }, { replace: true });
    if (window.innerWidth < 768) setTimeout(() => paneel.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);   // R3: telefoon
  };
  const opnieuw = () => { setVersie((v) => v + 1); laad(); };
  const naSluiten = async (res) => {
    try { await api.post(`/afdelingen/${gekozen}/overleg/besproken`, { week: afsluit.week, afspraakId: afsluit.afspraak.id }); }
    catch (e) { toast.error(e?.response?.data?.detail || "Besproken markeren mislukt"); }
    setAfsluit(null); opnieuw();
  };

  if (fout) return <LoadError error={fout} onRetry={laad} testid="afdelingen-error" />;
  if (!data) return <div data-testid="afdelingen-laden" className="p-12 text-center text-sm text-zinc-400">Laden…</div>;
  return (
    <div data-testid="afdelingen-page" className="pb-24 md:pb-0">
      <div className="mb-3 md:mb-4">
        <h1 className="font-heading text-2xl font-black tracking-tight text-zinc-900">Afdelingen</h1>
        <p className="text-sm text-zinc-500">Het weekoverleg met elke afdeling: afspraken doorlopen, vaste vragen, notitie.</p>
      </div>
      {data.afdelingen.length === 0 ? (
        <p data-testid="afdelingen-leeg" className="text-sm text-zinc-500">Er zijn nog geen actieve afdelingen. Voeg ze toe in Instellingen → Afdelingen.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-[300px_minmax(0,1fr)] gap-5 items-start">
          <AfdelingLijst data={data} gekozen={gekozen} onKies={kies} />
          <div ref={paneel} className="scroll-mt-4">{gekozen && <OverlegPaneel key={gekozen} afdelingId={gekozen} versie={versie} onGewijzigd={laad}
            onActie={(a, status, week) => setAfsluit({ afspraak: a, status, week })} onNieuw={() => setNieuw(true)} />}</div>
        </div>
      )}
      <AfspraakAfsluitDialog open={!!afsluit} onOpenChange={(o) => { if (!o) setAfsluit(null); }} afspraak={afsluit?.afspraak} status={afsluit?.status}
        vervolgStandaard={afsluit?.status === "niet"} onSaved={naSluiten} />
      {meta && (
        <AfspraakDialog open={nieuw} onOpenChange={setNieuw} week={currentWeek()} locaties={meta.locations || []} generalBuckets={meta.generalBuckets || []}
          oms={meta.oms || []} internKandidaten={meta.internKandidaten || []} blContact={meta.blContact || {}} afdelingen={meta.afdelingen || []}
          defaultLocatie="" defaultAfdeling={gekozen} onCreated={opnieuw} />
      )}
    </div>
  );
}
